import React, { useState, useEffect, useMemo } from "react";
import styles from "./index.module.css";
import Button, { ButtonPurpose, ButtonSize } from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import Table from "shared/Table";
import { Modal } from "shared/Modal";
import { useGracePeriod } from "./useGracePeriod";
import EditGracePeriod from "./EditGracePeriod";
import RemoveGracePeriod from "./RemoveGracePeriod";
import classNames from "classnames";
import PagingControls from "shared/PagingControls";
import Loader from "shared/Loader";
import TabActionBar from "shared/TabActionBar";

import nanobus from "nanobus";
import AddGracePeriod from "./AddGracePeriod/AddGracePeriod";
import { useAwards } from "./../External/useAwards";
import formatDate from "shared/@utils/formatDate";

export default function GracePeriod() {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const events = useMemo(() => nanobus(), []);

  const { awards } = useAwards();

  const { records, loading, isWaiting, refresh } = useGracePeriod({
    page,
    limit,
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const selected = records && records.data[selectedIndex];

  useEffect(() => {
    if (loading) {
      events.emit("refresh:start");
    } else {
      events.emit("refresh:end");
    }
  }, [loading, events]);

  // Listen for refresh events on mount and stop listening when unmounted.
  useEffect(() => {
    const listener = () => {
      refresh();
    };

    events.on("refresh", listener);

    return () => {
      events.removeListener("refresh", listener);
    };
  }, [refresh, events]);

  const [showPluginModal, setShowPluginModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  return (
    <>
      <TabActionBar>
        <Button
          onClick={() => {
            setShowPluginModal(true);
          }}
        >
          Add Plugin
        </Button>
      </TabActionBar>

      <div className={styles.tableContainer}>
        {records == null ? (
          <Loader />
        ) : (
          <>
            <Table
              className={classNames({
                [styles.loading]: loading,
              })}
            >
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>IBO Number</th>
                  <th>Grace Award</th>
                  <th>New Award</th>
                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Years Diamond +</th>
                  <th style={{ textAlign: "right" }}>Remove</th>
                </tr>
              </thead>
              <tbody>
                {records.data.map((r, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        <Button
                          size={ButtonSize.small}
                          onClick={() => {
                            setShowEditModal(true);
                          }}
                        >
                          Edit
                        </Button>
                      </td>
                      <td>{r.iboNumber}</td>
                      {awards ? (
                        // <td>{awards[r.graceAward - 1].wwgDesc}</td>
                        <td>{awards[r.graceAward].wwgDesc}</td>
                      ) : (
                        <td>Loading Awards...</td>
                      )}
                      {awards ? (
                        // <td>{awards[r.newAward - 1].wwgDesc}</td>
                        <td>{awards[r.newAward].wwgDesc}</td>
                      ) : (
                        <td>Loading Awards...</td>
                      )}
                      <td>{formatDate(r.periodStart)}</td>
                      <td>{formatDate(r.periodEnd)}</td>
                      <td>{r.yearsDiamondPlus}</td>
                      <td align="right">
                        <Button
                          size={ButtonSize.small}
                          purpose={ButtonPurpose.delete}
                          onClick={() => {
                            setShowRemoveModal(true);
                          }}
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <div className={styles.pagingControls}>
              <PagingControls
                page={page}
                limit={limit}
                onPageChange={setPage}
                onLimitChange={setLimit}
                disableNext={records.length < limit}
                disabled={loading || isWaiting}
              />
            </div>
          </>
        )}
      </div>

      {/* Add Plugin Modal */}
      <Modal
        title="New Grace Period"
        isOpen={showPluginModal}
        onClose={() => {
          setShowPluginModal(false);
        }}
      >
        <AddGracePeriod
          refresh={() => {
            refresh();
          }}
          onClose={() => {
            setShowPluginModal(false);
            refresh();
          }}
        />
      </Modal>

      {/* Edit Modal */}
      <Modal
        title="Edit Grace Period"
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false);
        }}
      >
        <EditGracePeriod
          record={selected}
          refresh={refresh}
          onClose={() => {
            setShowEditModal(false);
          }}
        />
      </Modal>
      {/* Remove Modal */}
      {selected && (
        <Modal
          title={"Delete Graceperiod " + selected.iboNumber + "?"}
          isOpen={showRemoveModal}
          onClose={() => {
            setShowRemoveModal(false);
          }}
        >
          <RemoveGracePeriod
            record={selected}
            awards={awards}
            onClose={() => {
              setShowRemoveModal(false);
              refresh();
            }}
          />
        </Modal>
      )}
    </>
  );
}
